/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { DeviceModel } from "../../model/device";
import { RetryMechanism } from "../../model/retrymechanism";
import { resetManualRetry } from "./manualRetryController";

/**
 * Exit action for the connection-error overlay: discards any pending manual
 * retry wake, drops in-flight deduplicated requests, then closes the app
 * through the existing platform abstraction.
 *
 * Lives in the viewModel so the view-layer bridge does not reach into
 * `src/model` directly (MVVM layering gate).
 */
export function exitApplicationFromConnectionOverlay(): void {
  resetManualRetry();
  RetryMechanism.clearPendingRequests();
  DeviceModel.closeApplication();
}
